"use strict";
exports.__esModule = true;
exports.SUBMIT_STATUS_PENDING = exports.SUBMIT_STATUS_FAILURE = exports.SUBMIT_STATUS_SUCCESS = void 0;
exports.SUBMIT_STATUS_SUCCESS = 'SUBMIT_STATUS_SUCCESS';
exports.SUBMIT_STATUS_FAILURE = 'SUBMIT_STATUS_FAILURE';
exports.SUBMIT_STATUS_PENDING = 'SUBMIT_STATUS_PENDING';
